import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clip",
  "use": "icon-clip-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-clip\">\n  <g fill-rule=\"evenodd\">\n    <path d=\"M17.5 7.262v10c0 2.895-2.236 5.238-5 5.238s-5-2.343-5-5.238V6.31c0-2.105 1.627-3.81 3.636-3.81 2.01 0 3.637 1.705 3.637 3.81v10c0 1.314-1.018 2.38-2.273 2.38-1.255 0-2.273-1.066-2.273-2.38V7.261h.91v9.047c0 .79.61 1.43 1.363 1.43s1.364-.64 1.364-1.43V6.31c0-1.578-1.222-2.858-2.728-2.858-1.506 0-2.727 1.28-2.727 2.858V17.262c0 2.367 1.832 4.286 4.091 4.286 2.26 0 4.09-1.92 4.09-4.286v-10h.91z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol